(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pimosfer-collage-tabs"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-collage-tabs]').forEach((section) => {
    section.querySelectorAll('[data-collage-tab]').forEach((tab, index) => {
      tab.addEventListener('click', () => {
        section.querySelectorAll('[data-collage-tab]').forEach((item) => item.setAttribute('aria-selected', 'false'));
        section.querySelectorAll('[data-collage-panel]').forEach((panel) => { panel.hidden = true; });
        tab.setAttribute('aria-selected', 'true');
        section.querySelectorAll('[data-collage-panel]')[index].hidden = false;
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pimosfer-countdown"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-countdown]').forEach((section) => {
    const target = Date.parse(section.dataset.countdown);
    if (Number.isNaN(target)) return;
    const update = () => {
      const distance = target - Date.now();
      if (distance <= 0) {
        section.querySelector('.pimosfer-countdown__timer').textContent = section.dataset.expiredText;
        return false;
      }
      const values = {
        days: Math.floor(distance / 86400000),
        hours: Math.floor(distance / 3600000) % 24,
        minutes: Math.floor(distance / 60000) % 60,
        seconds: Math.floor(distance / 1000) % 60
      };
      Object.entries(values).forEach(([unit, value]) => {
        section.querySelector(`[data-countdown-unit="${unit}"]`).textContent = String(value).padStart(2, '0');
      });
      return true;
    };
    update();
    const interval = setInterval(() => { if (!update()) clearInterval(interval); }, 1000);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pimosfer-newsletter-popup"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('newsletter-popup')) {
    class NewsletterPopup extends HTMLElement {
      connectedCallback() {
        this.dialog = this.querySelector('dialog');
        this.closeButton = this.querySelector('.pimosfer-newsletter-popup__close');
        this.subscribedKey = 'pimosfer_newsletter_subscribed';
        this.dismissedKey = 'pimosfer_newsletter_dismissed_at';
        this.pendingKey = 'pimosfer_newsletter_pending';
        this.boundSubmit = this.handleSubmit.bind(this);

        if (!this.dialog) return;

        this.closeButton?.addEventListener('click', () => this.dismiss());
        this.dialog.addEventListener('click', (event) => {
          if (event.target === this.dialog) this.dismiss();
        });
        this.dialog.addEventListener('cancel', (event) => {
          event.preventDefault();
          this.dismiss();
        });
        document.addEventListener('submit', this.boundSubmit);
        window.addEventListener('storage', () => this.syncSubscribedState());

        const postedSuccessfully = this.querySelector('[data-newsletter-posted-successfully]');
        const postedFromNewsletter = sessionStorage.getItem(this.pendingKey) === 'true';
        const urlSuccess = new URLSearchParams(window.location.search).get('customer_posted') === 'true';

        if (postedSuccessfully || (postedFromNewsletter && urlSuccess)) {
          this.markSubscribed();
          return;
        }

        this.syncSubscribedState();
        this.schedule();
      }

      disconnectedCallback() {
        document.removeEventListener('submit', this.boundSubmit);
      }

      handleSubmit(event) {
        if (!event.target.matches('form.pimosfer-newsletter-form')) return;
        sessionStorage.setItem(this.pendingKey, 'true');
      }

      isSubscribed() {
        return this.dataset.subscribed === 'true' || localStorage.getItem(this.subscribedKey) === 'true';
      }

      syncSubscribedState() {
        const subscribed = this.isSubscribed();
        document.documentElement.classList.toggle('pimosfer-newsletter-subscribed', subscribed);
        if (!subscribed) return;

        document.querySelectorAll('form.pimosfer-newsletter-form').forEach((form) => {
          if (form.nextElementSibling?.classList.contains('pimosfer-newsletter-global-success')) return;
          const message = document.createElement('p');
          message.className = 'pimosfer-newsletter-global-success';
          message.textContent = 'You’re on the list.';
          form.insertAdjacentElement('afterend', message);
        });
        if (this.dialog.open) this.dialog.close();
      }

      markSubscribed() {
        localStorage.setItem(this.subscribedKey, 'true');
        sessionStorage.removeItem(this.pendingKey);
        this.syncSubscribedState();
      }

      wasRecentlyDismissed() {
        const dismissedAt = Number(localStorage.getItem(this.dismissedKey));
        const days = Number(this.dataset.dismissDays || 14);
        return dismissedAt > 0 && Date.now() - dismissedAt < days * 86400000;
      }

      schedule() {
        if (this.dataset.enabled !== 'true' || this.isSubscribed() || this.wasRecentlyDismissed()) return;

        if (this.dataset.designMode === 'true') {
          this.open();
          return;
        }

        this.timeReady = false;
        this.scrollReady = document.documentElement.scrollHeight <= window.innerHeight * 1.3;
        window.setTimeout(() => {
          this.timeReady = true;
          this.maybeOpen();
        }, Number(this.dataset.delay || 10000));

        this.handleScroll = () => {
          const scrollable = document.documentElement.scrollHeight - window.innerHeight;
          if (scrollable <= 0 || window.scrollY / scrollable >= 0.3) {
            this.scrollReady = true;
            window.removeEventListener('scroll', this.handleScroll);
            this.maybeOpen();
          }
        };
        window.addEventListener('scroll', this.handleScroll, { passive: true });
      }

      maybeOpen() {
        if (this.timeReady && this.scrollReady) this.open();
      }

      open() {
        if (this.dialog.open || this.isSubscribed()) return;
        this.dialog.showModal();
      }

      dismiss() {
        localStorage.setItem(this.dismissedKey, String(Date.now()));
        if (this.dialog.open) this.dialog.close();
      }
    }

    customElements.define('newsletter-popup', NewsletterPopup);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pimosfer-style-grid"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('pimosfer-style-motion')) {
    class PimosferStyleMotion extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('[data-style-track]');
        this.current = this.querySelector('[data-style-current]');
        this.progress = this.querySelector('[data-style-progress]');
        this.frame = null;
        if (!this.track) return;
        this.onScroll = () => {
          if (this.frame) return;
          this.frame = requestAnimationFrame(() => {
            this.frame = null;
            const max = Math.max(1, this.track.scrollWidth - this.track.clientWidth);
            const ratio = Math.min(1, Math.max(0, this.track.scrollLeft / max));
            const cards = Array.from(this.track.children);
            const index = cards.reduce((nearest, card, cardIndex) => {
              const currentDistance = Math.abs(card.offsetLeft - this.track.scrollLeft);
              return currentDistance < nearest.distance ? { index: cardIndex, distance: currentDistance } : nearest;
            }, { index: 0, distance: Number.POSITIVE_INFINITY }).index;
            if (this.current) this.current.textContent = String(index + 1).padStart(2, '0');
            if (this.progress) this.progress.style.setProperty('--style-progress', ratio);
          });
        };
        this.track.addEventListener('scroll', this.onScroll, { passive: true });
        this.onScroll();
      }

      disconnectedCallback() {
        this.track?.removeEventListener('scroll', this.onScroll);
        if (this.frame) cancelAnimationFrame(this.frame);
      }
    }
    customElements.define('pimosfer-style-motion', PimosferStyleMotion);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pimosfer-why"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('pimosfer-why-motion')) {
    class PimosferWhyMotion extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('[data-why-track]');
        this.items = Array.from(this.querySelectorAll('.pimosfer-why__principle'));
        this.current = this.querySelector('[data-why-current]');
        this.progress = this.querySelector('[data-why-progress]');

        if (!this.track || this.items.length === 0) return;

        this.frame = null;
        this.onScroll = () => {
          if (this.frame) return;
          this.frame = requestAnimationFrame(() => {
            this.frame = null;
            this.updateProgress();
          });
        };

        this.track.addEventListener('scroll', this.onScroll, { passive: true });
        this.updateProgress();
      }

      disconnectedCallback() {
        this.track?.removeEventListener('scroll', this.onScroll);
        if (this.frame) cancelAnimationFrame(this.frame);
      }

      updateProgress() {
        const maxScroll = Math.max(1, this.track.scrollWidth - this.track.clientWidth);
        const ratio = Math.min(1, Math.max(0, this.track.scrollLeft / maxScroll));
        const viewportCenter = this.track.scrollLeft + this.track.clientWidth / 2;
        let activeIndex = 0;
        let activeDistance = Number.POSITIVE_INFINITY;

        this.items.forEach((item, index) => {
          const itemCenter = item.offsetLeft + item.offsetWidth / 2;
          const distance = Math.abs(itemCenter - viewportCenter);
          if (distance < activeDistance) {
            activeDistance = distance;
            activeIndex = index;
          }
        });

        this.items.forEach((item, index) => item.toggleAttribute('data-active', index === activeIndex));
        if (this.current) this.current.textContent = String(activeIndex + 1).padStart(2, '0');
        if (this.progress) this.progress.style.setProperty('--why-progress', ratio);
      }
    }

    customElements.define('pimosfer-why-motion', PimosferWhyMotion);
  }

  } catch(e) { console.error(e); }
})();
})();
